import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "./App.css";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Tours from "./pages/Tours";
import TourDetail from "./pages/TourDetail";
import About from "./pages/About";
import Contact from "./pages/Contact";
import PlaceDetail from "./pages/PlaceDetail";
import Wishlist from "./pages/Wishlist";
import MyBookings from "./pages/MyBookings";
import PublicWishlist from "./pages/PublicWishlist";
import Admin from "./pages/Admin";
import AuthCallback from "./pages/AuthCallback";
import FloatingWhatsApp from "./components/FloatingWhatsApp";
import { Toaster } from "./components/ui/toaster";
import { AuthProvider } from "./context/AuthContext";

/**
 * Read `session_id` synchronously from the current URL hash so that the OAuth
 * callback processes BEFORE our AuthProvider tries `/auth/me`.
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/tours" element={<Tours />} />
        <Route path="/tours/:id" element={<TourDetail />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/places/:id" element={<PlaceDetail />} />
        <Route path="/wishlist" element={<Wishlist />} />
        <Route path="/my-bookings" element={<MyBookings />} />
        <Route path="/w/:token" element={<PublicWishlist />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
      <Footer />
      <FloatingWhatsApp />
    </>
  );
}

function App() {
  return (
    <div className="App bg-[#F7F3EA] min-h-screen font-sans text-[#2A2118]">
      {/* Global SVG filter used to remove near-white background from raster logo */}
      <svg width="0" height="0" style={{ position: "absolute" }} aria-hidden="true">
        <defs>
          <filter id="removeWhite" colorInterpolationFilters="sRGB">
            <feColorMatrix
              type="matrix"
              values="1 0 0 0 0
                      0 1 0 0 0
                      0 0 1 0 0
                      -1 -1 -1 3 0"
            />
          </filter>
        </defs>
      </svg>
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
